import { ArrowUpRight, Flame } from "lucide-react";
import { PRODUCTS, IMAGES } from "../data/site";
import { Reveal } from "./Reveal";

const ProductCard = ({ product, large }) => (
  <div
    className={`group relative flex flex-col border border-zinc-800 bg-surface ${large ? "lg:col-span-7 lg:row-span-2" : "lg:col-span-5"}`}
    data-testid={`product-card-${product.id}`}
  >
    <div className="spotlight relative overflow-hidden">
      <div className={`${large ? "h-72 lg:h-[420px]" : "h-56"} overflow-hidden`}>
        <img
          src={IMAGES[product.img]}
          alt={product.name}
          className="clip-corner h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
      </div>
      <span
        className={`absolute left-4 top-4 flex items-center gap-2 px-3 py-1.5 font-mono-label text-[10px] ${
          product.featured ? "bg-copper text-ink" : "border border-zinc-700 bg-black/70 text-zinc-300 backdrop-blur-sm"
        }`}
        data-testid={`product-tag-${product.id}`}
      >
        {product.featured && <Flame size={12} />}
        {product.tag}
      </span>
    </div>

    <div className="flex flex-1 flex-col p-6 lg:p-8">
      {["left-2 top-2", "right-2 top-2", "left-2 bottom-2", "right-2 bottom-2"].map((p) => (
        <span key={p} className={`absolute ${p} z-10 h-1.5 w-1.5 rounded-full bg-zinc-600`} aria-hidden="true" />
      ))}
      <div className="flex items-start justify-between gap-4">
        <h3 className={`font-display font-semibold uppercase text-zinc-100 ${large ? "text-3xl lg:text-4xl" : "text-2xl"}`}>
          {product.name}
        </h3>
        <a
          href="#contact"
          data-testid={`product-quote-${product.id}`}
          aria-label={`Request quote for ${product.name}`}
          className="border border-zinc-700 p-2 text-zinc-400 transition-colors duration-300 hover:border-copper hover:text-copper-light"
        >
          <ArrowUpRight size={18} />
        </a>
      </div>
      <p className="mt-4 text-sm leading-relaxed text-zinc-400 md:text-base">{product.desc}</p>
      <ul className="mt-6 grid grid-cols-1 gap-2 sm:grid-cols-2">
        {product.specs.map((s) => (
          <li key={s} className="flex items-center gap-2 font-mono-label text-[10px] text-zinc-500">
            <span className="h-1 w-1 rotate-45 bg-copper" />
            {s}
          </li>
        ))}
      </ul>
      {product.featured && (
        <div className="mt-6 border border-dashed border-zinc-700 p-4" data-testid="coal-spec-sheet">
          <p className="font-stencil text-[10px] text-copper">Deal sheet // OMK-CU-100</p>
          <div className="mt-3 grid grid-cols-2 gap-x-6 gap-y-2 font-mono text-[11px]">
            <span className="text-zinc-500">ORIGIN</span>
            <span className="text-right text-zinc-300">ZAMBIA</span>
            <span className="text-zinc-500">PRICE</span>
            <span className="text-right text-copper-light">10% BELOW LME</span>
            <span className="text-zinc-500">MIN. ORDER</span>
            <span className="text-right text-zinc-300">100 MT</span>
            <span className="text-zinc-500">PAYMENT</span>
            <span className="text-right text-zinc-300">30% ADV · 70% AT PORT</span>
          </div>
        </div>
      )}
    </div>
  </div>
);

export const Products = () => (
  <section id="products" className="mx-auto max-w-[1400px] px-6 py-28 lg:px-12 lg:py-40" data-testid="products-section">
    <Reveal>
      <p className="font-mono-label text-xs text-copper">01 — What we move</p>
      <h2 className="font-display mt-6 max-w-3xl text-4xl font-semibold uppercase leading-tight text-zinc-100 sm:text-5xl lg:text-6xl">
        Commodities, <span className="text-copper">at scale.</span>
      </h2>
    </Reveal>

    <div className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-12">
      {PRODUCTS.map((p, i) => (
        <Reveal key={p.id} delay={i * 0.12} className={p.featured ? "lg:col-span-7 lg:row-span-2" : "lg:col-span-5"}>
          <ProductCard product={p} large={p.featured} />
        </Reveal>
      ))}
    </div>
  </section>
);
